import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "./styles.css";

document.documentElement.lang = window.localStorage.getItem("echos-events-locale") === "en" ? "en" : "tr";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    {import.meta.env.VITE_ECHOS_ENV === "dev" && <div className="dev-environment-badge" role="note">DEV · Test data only · Emails &amp; Sheets off</div>}
    <App />
  </StrictMode>,
);
